export default __webpack_public_path__ + "static/media/NE.093cdd29.svg";